import { styled, Typography } from '@mui/material'

const PinkTitle = styled(Typography)({
  fontSize: '14px',
  fontWeight: 600,
  lineHeight: '20px',
  color: '#F06292',
})

export default PinkTitle
